// extracted by mini-css-extract-plugin
module.exports = {"footer":"ConfirmDeleteChannelModal_footer__Fss1I","text":"ConfirmDeleteChannelModal_text__14uoN"};